module.exports = __webpack_public_path__ + "static/media/tournaments-thumb.eab48244.png";